import { handleActions, createAction } from 'redux-actions';
import { getDataProvider } from '../../data-providers';
import { formatAddressForSaving } from './shipping-address';

export const makeMonthlyPayment = (hasFreeTrial) => {
  return makePayment('monthly', hasFreeTrial);
};

export const makeYearlyPayment = () => {
  return makePayment('yearly');
};

const makePayment = createAction('MAKE_PAYMENT', (paymentType, hasFreeTrial = false) => {
  return getDataProvider().makePayment(paymentType, hasFreeTrial);
});

export const getActivationCode = createAction('GET_ACTIVATION_CODE', (code) => {
  return getDataProvider().getActivationCode(code);
});

export const redeemActivationCode = createAction('REDEEM_ACTIVATION_CODE', (code, items, shippingAddress) => {
  if (shippingAddress) {
    return getDataProvider().redeemActivationCode(code, items, formatAddressForSaving(shippingAddress));
  }
  return getDataProvider().redeemActivationCode(code, items);
});

export default handleActions({
  [`${makePayment}_PENDING`]: (state) => {
    return Object.assign({}, state, {});
  },
  [`${makePayment}_FULFILLED`]: (state, action) => {
    return Object.assign({}, state, {});
  },
  [`${makePayment}_REJECTED`]: (state) => {
    return Object.assign({}, state, {});
  },
  [`${getActivationCode}_FULFILLED`]: (state, action) => {
    return { ...action.payload };
  },
  [`${getActivationCode}_REJECTED`]: (state, action) => {
    return { ...action.payload };
  }
}, {});
